export default __webpack_public_path__ + "static/media/pollution-frame-1.49f50ec1.jpg";